<form #formRef="ngForm" class="sidebar-active">
	<bb-page-header [backOnMobile]="['/library/lineups']" [icon]="'tv'" [title]="entity ? entity.name : 'LINEUP' | translate">
		<ul class="tabs" *ngIf="entity">
			<li>
				<a [routerLink]="['/library/lineup', activeId, 'general']" routerLinkActive="" [class.active]="activeTab === 'general'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'GENERAL' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/lineup', activeId, 'cycles']" routerLinkActive="" [class.active]="activeTab === 'cycles'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tv"></i> {{ 'CYCLES' | translate }}
					<span
						*ngIf="tabInfoIcons.cycles?.warning || tabInfoIcons.cycles?.error || tabInfoIcons.cycles?.checked === false"
						class="icon-warning"
						[title]="tabInfoIcons.cycles?.notification ? tabInfoIcons.cycles?.notification : ''"
					>
						<span class="divider-pipe">|</span> <i class="fas fa-{{ tabInfoIcons.cycles?.error ? 'exclamation-circle' : 'warning' }}"></i>
					</span>
				</a>
			</li>
			<li>
				<a [routerLink]="['/library/lineup', activeId, 'configuration']" routerLinkActive="" [class.active]="activeTab === 'configuration'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-cogs"></i> {{ 'CONFIGURATION' | translate }}
					<span
						*ngIf="tabInfoIcons.configuration?.warning || tabInfoIcons.configuration?.error || (containsSlideshowPlaylist && tabInfoIcons.configuration?.checked === false)"
						class="icon-warning"
						[title]="tabInfoIcons.configuration?.notification ? tabInfoIcons.configuration?.notification : ''"
					>
						<span class="divider-pipe">|</span> <i class="fa fa-{{ tabInfoIcons.configuration?.error ? 'exclamation-circle' : 'warning' }}"></i>
					</span>
				</a>
			</li>
			<li *ngIf="mediaclip">
				<a [routerLink]="['/library/lineup', activeId, 'embed']" routerLinkActive="" [class.active]="activeTab === 'embed'"><!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-code"></i> {{ 'EMBED' | translate }}
				</a>
			</li>
		</ul>
	</bb-page-header>

	<div class="body-column tab-container">
		<lineup-details-general *ngIf="entity" [form]="form" [lineup]="entity" [hidden]="activeTab !== 'general'"></lineup-details-general>
		<lineup-details-cycles *ngIf="entity" [form]="form" [lineup]="entity" [hidden]="activeTab !== 'cycles'"></lineup-details-cycles>
		<lineup-details-configuration *ngIf="entity" [form]="form" [lineup]="entity" [hidden]="activeTab !== 'configuration'" [containsSlideshowPlaylist]="containsSlideshowPlaylist"></lineup-details-configuration>
		<lineup-details-embed *ngIf="entity" [form]="form" [lineup]="entity" [mediaclip]="mediaclip" [hidden]="activeTab !== 'embed'"></lineup-details-embed>
	</div>

	<!-- preview (embed) -->
	<div class="body-column preview-container">
		<ng-container *ngIf="mediaclip && entity.channelState === 'RUNNING'">
			<h3 >{{'PREVIEW' | translate}}</h3>
			<div class="preview-wrapper">
				<div>
					<bb-player
						[transparentBackground]="false"
						[mediaclip]="mediaclip" 
						[autoplay]="false"
						[playoutOverrides]="{width: '100%', responsiveSizing: 'true', allowImageSequence:'false', fullScreen:'Hide'}"></bb-player>
				</div>
			</div>
		</ng-container>

		<bb-checklist [items]="checklistItems"></bb-checklist>
		<div class="channel-state" *ngIf="entity">
			<h3>
				{{ 'CHANNEL_STATUS' | translate }}
			</h3>
			<div class="line">
				<label>
					{{ 'CURRENT_STATUS' | translate }}
				</label>
				<div class="input">
					<div class="status">
						{{ ( !entity.cfnId ? 'UNPUBLISHED' : (entity.channelRestarting ? 'RESTARTING' : (entity.channelState || 'IDLE')) ) | translate }}
					</div>
				</div>
			</div>
			<div *ngIf="!(entity.channelState && entity.id)">
				<bb-button
					[disabled]="true"
					[icon]="'play'"
				>
					{{ 'START' | translate }}
				</bb-button>
			</div>
			<div *ngIf="entity.channelRestarting">
				<bb-button
					[disabled]="true"
					[loading]="true"
					[icon]="'refresh'"
				>
					{{ 'RESTARTING' | translate }}
				</bb-button>
			</div>
			<div class="line" *ngIf="entity.channelState && entity.id && !entity.channelRestarting">
				<label></label>
				<div class="buttons">
					<bb-button
						*ngIf="entity.channelState !== 'RUNNING' && entity.channelState !== 'STARTING'"
						[icon]="'play'"
						[loading]="updatingStatus"
						(click)="onStartClick()"
					>
						{{ (updatingStatus ? entity.channelState : 'START') | translate }}
					</bb-button>
					<bb-button
						*ngIf="entity.channelState !== 'IDLE' && entity.channelState !== 'STOPPING'"
						[icon]="'stop'"
						[loading]="updatingStatus"
						(click)="onStopClick()"
					>
						{{ (updatingStatus ? entity.channelState : 'STOP') | translate }}
					</bb-button>
					<bb-button
						*ngIf="!updatingStatus && entity.channelState === 'RUNNING'"
						[icon]="'refresh'"
						(click)="onRestartClick()"
					>
						{{ 'RESTART' | translate }}
					</bb-button>
				</div>
			</div>

			<div class="status-messages" *ngIf="errorMessagesLog?.length" [hasPublicationField]="'rootOnly'">
				<strong>{{ "ERROR_EVENT_LOG" | translate }}</strong>
				<div class="error-messages">
					<div class="error-dates">
						<p *ngFor="let message of errorMessagesLog">
							{{ message.createdDate | bbDate }}
						</p>
					</div>
					<div>
						<p *ngFor="let message of errorMessagesLog">
							 {{ message.error }}
						</p>
					</div>
				</div>
			</div>

			<div class="status-messages" *ngIf="channelUpdates?.length">
				<div
					*ngFor="let updateMessage of channelUpdates" class="msg"
					[@anim]="updateMessage.message"
				>
					<span class="time" [innerHTML]="updateMessage.time | bbDate:'time':'long'"></span>
					<span class="update">
						<i class="fa fa-exclamation-circle type-{{updateMessage.type}}" title="Error" *ngIf="updateMessage.type === 'error'"></i>
						<i class="fa fa-warning type-{{updateMessage.type}}" title="Warning" *ngIf="updateMessage.type === 'warning'"></i>
						{{ updateMessage.message }}
					</span>
				</div>
			</div>

			<div class="line">
				<label>
					{{ 'HOURS_ONLINE' | translate }}
					<bb-info [contents]="'HELP.HOURS_ONLINE' | translate" [icon]="'help'"></bb-info>
				</label>
				<div class="status">
					{{ this.hoursOnline | seconds}}
				</div>
			</div>
			
		</div>
		<bb-entity-details
			[entity]="entity"
		></bb-entity-details>
	</div>
</form>

<bb-versions
	*ngIf="showVersions && !!entity?.id"
	(clickOutside)="showVersions = false"
	[clickOutsideExcludeQueries]="['.history-button']"
	(versionSelected)="loadVersion($event)"
	(versionStateSelected)="setVersionState($event)" 
	[entityDetails]="entityDetails"
	[entityConfiguration]="entityConfiguration"
></bb-versions>

<bb-actions-bar
	(onPublish)="lineupDetailsConfigurationComponent.checkValidInputs();publish()"
	(onSave)="save($event)"
	(onCancel)="cancel()"
	(onDelete)="delete($event)"
	[form]="form"
	[entity]="entity"
	[entityConfiguration]="entityConfiguration"
>
	<div class="action-button position-start history-button" *ngIf="!!entity?.id">
		<div (click)="showVersions = !showVersions" #historyButton>
			{{ 'HISTORY' | translate }}
			<i class="fa fa-angle-up" *ngIf="showVersions"></i>
			<i class="fa fa-angle-down" *ngIf="!showVersions"></i>
		</div>
	</div>
</bb-actions-bar>
